import DashboardTeamMovementPoints from './DashboardTeamMovementPoints';
export default DashboardTeamMovementPoints;
